import { render, staticRenderFns } from "./TestingChangeApproval.vue?vue&type=template&id=383efb3c"
import script from "./TestingChangeApproval.vue?vue&type=script&lang=ts"
export * from "./TestingChangeApproval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports